module.exports = __webpack_public_path__ + "static/media/wb-banner-definitive.8d9d59b2.svg";